import { slugifyString } from "../../utils/slugifyString";
import { ObjectType, ElementObject } from "../types";

type BuildElementObject = (elementName: string) => ElementObject;

const buildElementObject: BuildElementObject = (elementName) => {
  const slugifiedElementName = slugifyString(elementName);

  const elementId = `element:${slugifiedElementName}`;

  return {
    type: ObjectType.Element,
    id: elementId,
    name: elementName.trim(),
  };
};

export { buildElementObject };
